import { render } from "./FileGalleria.vue?vue&type=template&id=17d1c2a0&scoped=true"
import script from "./FileGalleria.vue?vue&type=script&lang=js"
export * from "./FileGalleria.vue?vue&type=script&lang=js"

import "./FileGalleria.vue?vue&type=style&index=0&id=17d1c2a0&scoped=true&lang=css"

import exportComponent from "/var/www/karman/karman_crm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17d1c2a0"]])

export default __exports__